/**
 * Shared background gradient and orb styles for auth panels and Membership homepage.
 * Keeps Login/Registration right panel and left panel visually aligned with MembershipHome.
 */
import type { SxProps, Theme } from "@mui/material";

/** Same as MembershipHome: 135deg, lighter top-left (#667eea) → darker bottom-right (#4c2a85) */
export const AUTH_MEMBERSHIP_GRADIENT =
  "linear-gradient(135deg, #667eea 0%, #764ba2 25%, #6f49c9 50%, #5b36b0 75%, #4c2a85 100%)";

/** Root container for auth/membership full-height gradient + orbs */
export const authBackgroundContainerSx: SxProps<Theme> = {
  minHeight: "100vh",
  position: "relative",
  overflow: "hidden",
  background: AUTH_MEMBERSHIP_GRADIENT
};

/** Orb 1 – top-right (same as MembershipHome) */
export const authOrb1Sx: SxProps<Theme> = {
  position: "absolute",
  top: "-50%",
  right: "-20%",
  width: "600px",
  height: "600px",
  borderRadius: "50%",
  background:
    "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
  animation: "authMembershipFloat 20s ease-in-out infinite",
  "@keyframes authMembershipFloat": {
    "0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
    "50%": { transform: "translate(-30px, -30px) rotate(180deg)" }
  }
};

/** Orb 2 – bottom-left (same as MembershipHome, reverse animation) */
export const authOrb2Sx: SxProps<Theme> = {
  position: "absolute",
  bottom: "-30%",
  left: "-10%",
  width: "500px",
  height: "500px",
  borderRadius: "50%",
  background:
    "radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)",
  animation: "authMembershipFloat 15s ease-in-out infinite reverse"
};

/** Desktop welcome hero — video backdrop (83vh scroll affordance below) */
export const welcomeBackgroundContainerSx: SxProps<Theme> = {
  minHeight: "83vh",
  height: "83vh",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  background: "#000"
};

/** Desktop-only full-bleed video wrapper */
export const welcomeVideoWrapperSx: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  background: "#000",
  zIndex: 0
};

/** Desktop-only video — cover fills the viewport */
export const welcomeVideoSx: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  minWidth: "100%",
  minHeight: "100%",
  width: "auto",
  height: "auto",
  transform: "translate(-50%, -50%)",
  objectFit: "cover",
  objectPosition: "center center",
  pointerEvents: "none"
};
